<template>
  <form @submit.prevent="reset" style="max-width: 500px;width: 100%;">
    <Alert type="danger" :messages="errors"/>
    <Alert type="success" :messages="messages"/>
    <div class="login-container">
      <div class="form-group custom-form-group">
          <label>メールアドレス</label>
          <input type="email" v-model="email" class="form-control" name="email"
                  v-validate="'required|email'"
                  data-vv-as="メールアドレス"
                  placeholder="sample@mail.com" id="email">
          <!-- <i class="front-icon fa fa-envelope" aria-hidden="true"></i> -->
          <FieldError :message="formErrors.first('email')"/>
       </div>
      <div class="form-group custom-form-group ">
          <label>パスワード (<span> 数字、大小それぞれのアルファベット、および記号をそれぞれ1文字以上含めた8文字以上で設定してください</span>)</label>
          <div class="input-wrapper position-relative">
            <input :type="passwordType" v-model="password" class="form-control" name="password"
                   v-validate="'required|min:8|alhpanum_upper_lower_special'"
                   data-vv-as="パスワード"
                   placeholder="******" id="password" ref="password"
                   data-vv-delay="0">
            <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
            <button class="btn-eye eye-first" type="button" @click="showPassword = !showPassword">
              <i class="fa" :class="passwordEyeIcon" aria-hidden="true"></i>
            </button>
          </div>  
          <FieldError :message="formErrors.first('password')"/>
      </div>
      <div class="form-group custom-form-group">
          <label>パスワードの再入力</label>
          <div class="input-wrapper position-relative">
            <input :type="passwordType" v-model="confirm_password" class="form-control"
                   name="confirm_password" v-validate="'confirmed:password'"
                   data-vv-as="パスワード"
                   placeholder="******"
                   id="confirm_password" data-vv-delay="0">
            <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
            <button class="btn-eye eye-second" type="button" @click="showPassword = !showPassword">
              <i class="fa" :class="passwordEyeIcon" aria-hidden="true"></i>
            </button>
          </div>
          <FieldError :message="formErrors.first('confirm_password')"/>
      </div>
      <div class="mb-30">
        <!-- <router-link to="/" class="forgot-link">
          Back to Login
        </router-link> -->
      </div>
      <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <router-link to="/" class="btn btn-outline-danger me-1">キャンセル</router-link>
        <button class="btn btn-primary" type="submit" :disabled="!isFormValid">
          登録
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import Api from '@/config/api';
import axios from '@/http';
export default {
  name: 'Reset',
  components: { Alert, FieldError },
  data() {
    return {
      email: '',
      password: '',
      confirm_password: '',
      token: '',
      showPassword: false,
      loading: false,
      errors: [],
      messages: [],
    };
  },
  created() {
    this.token = this.$route.params.token;
  },
  computed: {
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordEyeIcon() {
      return this.showPassword ? 'fa-eye' : 'fa-eye-slash';
    },
    isFormValid() {
      const { email, password, confirm_password: confirm } = this.Vfields;
      if (email && password && confirm) {
        return email.changed && password.changed && confirm.changed &&
          this.formErrors.count() === 0;
      }
      return false;
    },
    payload() {
      return {
        email: this.email,
        password: this.password,
        confirm_password: this.confirm_password,
      };
    },
  },
  methods: {
    reset() {
      if (!this.isFormValid) return false;

      this.errors = [];
      this.messages = [];

      return axios.post(Api.endpoints.RESET_PASSWORD(this.token), this.payload)
        .then(() => {
          this.messages.push('パスワードが変更されました。');
          setTimeout(() => {
            this.$router.push('/');
          }, 1000);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>

  label {
    color: #617776;
    font-weight: bold;
  }
  .position-relative {
    position: relative;
  }
  .btn-eye{
    position: absolute;
  }
  .eye-first {
    top:5%;
    right: 10px;
  }

  .eye-second {
    top: 5%;
    right: 10px;
  }
  .custom-form-group .is-valid  {
    background-image: none!important;
  }


  .custom-form-group .is-invalid {
    background-image: none!important;
  }

  .custom-group input.form-control:focus::placeholder{
    color: white !important;
    text-shadow: none !important;
  }

  .custom-form-group input.form-control::placeholder{
    color: #b4b2b2 !important;
  }

</style>